import React, { useState, useEffect } from 'react';
import { Wizard } from '@sogei/react-web-components-catalog'

const AddWizard = (props) => {
    const [step, setStep] = useState([{
        stepNumber: 1,
        title: 'Data entry',
        description: '',
        done: true,
        href: ''
    }, {
        stepNumber: 2,
        title: 'Confirmation',
        description: '',
        done: true,
        href: '#'
    }, {
        stepNumber: 3,
        title: 'Summary',
        description: '',
        done: false,
        href: '#'
    }])

    useEffect(() => {
        let stepSelected = step.find(a => a.stepNumber === props.index);

        let newArray = step.map(x => {
            if (x.stepNumber <= stepSelected.stepNumber) {
                return {
                    ...x,
                    done: true,
                }
            } else if (x.stepNumber >= stepSelected.stepNumber) {
                return {
                    ...x,
                    done: false,
                }
            } else if (x.stepNumber == 1) {
                return {
                    ...x
                }
            }
        });
        setStep(newArray);

    }, [])

    return <Wizard currentStep={props.index} steps={step}> </Wizard>
}


export default AddWizard;
